import * as C from "../../constants";

const initialState = {
  initialized: false,
  isProcessing: false,
  selectedIndex: -1,
  selectedEnrollment: {},
  enrollments: [],
  errorMessage: "",
  successMessage: "",
  showSnackBar: false,
  page: 0,
  limit: 100,
  hasNext: false,
  total: 0,
};

const loadEnrollment = (state, action) => {
  return {
    ...state,
    ...action,
  };
};

const loadMoreEnrollments = (state, action) => {
  if (!action?.enrollments) return state;
  return {
    ...state,
    enrollments: [...state.enrollments, ...action.enrollments],
    page: action.page,
    hasNext: action.hasNext,
  };
};

const closeSnackbar = (state) => {
  return {
    ...state,
    errorMessage: "",
    successMessage: "",
    showSnackBar: false,
  };
};

const setErrorMessage = (state, action) => {
  return {
    ...state,
    errorMessage: action.message,
    showSnackBar: true,
  };
};

const setSuccessMessage = (state, action) => {
  return {
    ...state,
    successMessage: action.message,
    showSnackBar: true,
  };
};

export default function memberEnrollments(state = initialState, action) {
  switch (action.type) {
    case C.MEMBER_ENROLLMENT_SEARCH_TOGGLE_PROCESSING:
      return {
        ...state,
        isProcessing: !state.isProcessing,
      };
    case C.MEMBER_ENROLLMENT_SEARCH_SUCCESS:
      return loadEnrollment(state, action);
    case C.MEMBER_ENROLLMENT_SEARCH_LOAD_SUCCESS:
      return loadMoreEnrollments(state, action);
    case C.MEMBER_ENROLLMENT_SET_ERROR_MESSAGE:
      return setErrorMessage(state, action);
    case C.MEMBER_ENROLLMENT_SET_SUCCESS_MESSAGE:
      return setSuccessMessage(state, action);
    case C.MEMBER_ENROLLMENT_CLOSE_SNACKBAR:
      return closeSnackbar(state);
    default:
      return state;
  }
}
